import React from 'react';
import classNames from 'classnames';

import './PricingComponent.scss';
import PricingComponentToggle from './PricingComponentToggle';

export default function PricingComponent({ prices }) {
	return (
		<div className="pricing-component">
			{prices.map(price => {
				return (
					<React.Fragment key={price.title}>
						<div className="pricing-component__row ty-c2" key={price.title}>
							<div>
								<div className="pricing-component__row__title">{price.title}</div>
								{price.subTitle && (
									<div className="pricing-component__row__subtitle">{price.subTitle}</div>
								)}
							</div>
							<div
								className={classNames('ty-c1', {
									'ty-c2': price.title === 'Average nightly rate',
								})}
							>
								{price.amount}
							</div>
						</div>
						{price.toggle && (
							<PricingComponentToggle title={price.toggle.subTitle}>
								<div className="pricing-component__row__toggle-children ty-c2">
									{price.toggle.options.map(option => {
										return (
											<div className="toggle-children__row" key={option.date + option.price}>
												<div>{option.date}</div>
												<div>{option.price}</div>
											</div>
										);
									})}
								</div>
							</PricingComponentToggle>
						)}
					</React.Fragment>
				);
			})}
		</div>
	);
}
